import { call, put, select } from 'redux-saga/effects';
import types from '../redux/types';
import API from '../services/api';

function loadDefaultTemplates(templates, selectedTemplateId) {
  if (selectedTemplateId) templates[0];
  const selectedTemplate = templates.find(template => template.id === selectedTemplateId);
  return selectedTemplate || templates[0];
}

export function* fetchAllAnalyticsTemplates(filter) {
  const templates = new Map();
  const visited = new Set();
  let pageToken = '';
  do {
    visited.add(pageToken);
    const response = yield call(API.getTemplates, pageToken, filter);
    (response.templates || []).forEach(template => templates.set(template.id || template.name, template));
    pageToken = response.nextPageToken || '';
  } while (pageToken && !visited.has(pageToken));
  return { templates: [...templates.values()] };
}

export function* fetchTemplates() {
  const project = yield select(state => state.projectReducer.selectedProject);
  // const company = yield select(state => state.companyReducer.selectedCompany);
  const user = yield select(state => state.userReducer.user);

  // Check if there are any projects in current company
  if (project) {
    const pid = project.id;

    const datasourcesResponse = yield call(API.getDatasources, pid);

    // Get filter from datasources
    const filterList = datasourcesResponse.datasources.map(datasource => {
      return `compatibleDatasources = ['${datasource}']`;
    });

    const isVehicleCrowd =
      datasourcesResponse.datasources.some(datasource => datasource === 'AUDIENCE_M') &&
      datasourcesResponse.datasources.some(datasource => datasource === 'TRAFFIC_M');

    if (isVehicleCrowd) {
      filterList.push(`compatibleDatasources = ['TRAFFIC_M','AUDIENCE_M']`);
    }

    const analyticsFilterList = [...filterList];
    if (datasourcesResponse.datasources.includes('MOBILE_M') && datasourcesResponse.datasources.includes('AUDIENCE_M')) {
      analyticsFilterList.push(`compatibleDatasources = ['AUDIENCE_M','MOBILE_M']`);
    }

    let summaryTemplatesResponse = {};
    summaryTemplatesResponse = yield call(
      API.getTemplates,
      '',
      datasourcesResponse.datasources.length > 0
        ? `(${filterList.join(' OR ')}) AND (collection = 'SUMMARY' AND enabled = true)`
        : `(compatibleDatasources = ['AUDIENCE_M'] OR compatibleDatasources = ['TRAFFIC_M']) AND (collection = "SUMMARY" AND enabled = true)`
    );

    let analyticsTemplatesResponse = {};
    analyticsTemplatesResponse = yield call(
      fetchAllAnalyticsTemplates,
      datasourcesResponse.datasources.length > 0
        ? `(${analyticsFilterList.join(' OR ')}) AND (collection = 'ANALYTICS' AND enabled = true)`
        : `(compatibleDatasources = ['AUDIENCE_M'] OR compatibleDatasources = ['TRAFFIC_M']) AND (collection = "ANALYTICS" AND enabled = true)`
    );

    // CMS context may use an Audience+Mobile template even in a Mobile-only
    // project. Keep the normal dashboard choices/default separate from this catalog.
    let analyticsContextTemplates = analyticsTemplatesResponse.templates || [];
    if (datasourcesResponse.datasources.includes('MOBILE_M')) {
      const cmsCatalog = yield call(fetchAllAnalyticsTemplates, "collection = 'ANALYTICS' AND enabled = true");
      const mobileCmsTemplates = cmsCatalog.templates.filter(template => template.enabled !== false &&
        template.isCms && template.compatibleDatasources?.includes('MOBILE_M'));
      analyticsContextTemplates = [...new Map([...analyticsContextTemplates, ...mobileCmsTemplates]
        .map(template => [template.id || template.name, template])).values()];
    }

    let campaignTemplatesResponse = {};
    campaignTemplatesResponse = yield call(
      API.getTemplates,
      '',
      datasourcesResponse.datasources.length > 0
        ? `(${filterList.join(' OR ')}) AND (collection = 'CAMPAIGN' AND enabled = true)`
        : `(compatibleDatasources = ['AUDIENCE_M'] OR compatibleDatasources = ['TRAFFIC_M']) AND (collection = "CAMPAIGN" AND enabled = true)`
    );

    yield put({
      type: types.SELECT_SUMMARY_DASHBOARD,
      payload: loadDefaultTemplates(summaryTemplatesResponse?.templates, user.preferences?.defaultSummaryDashboard)
    });
    yield put({
      type: types.SELECT_ANALYTICS_DASHBOARD,
      payload: loadDefaultTemplates(analyticsTemplatesResponse?.templates, user.preferences?.defaultAnalyticsDashboard)
    });
    yield put({
      type: types.SELECT_CAMPAIGN_DASHBOARD,
      payload: loadDefaultTemplates(campaignTemplatesResponse?.templates, user.preferences?.defaultCampaignDashboard)
    });
    yield put({ type: types.LOAD_SUMMARY_TEMPLATES, payload: summaryTemplatesResponse?.templates });
    yield put({ type: types.LOAD_ANALYTICS_TEMPLATES, payload: analyticsContextTemplates });
    yield put({ type: types.LOAD_CAMPAIGN_TEMPLATES, payload: campaignTemplatesResponse?.templates });
  }
}
